import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { AuthService } from 'app/services/auth.service';
import { UnitTypeService } from 'app/services/models/unit-type.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-unit-type-list',
  templateUrl: './unit-type-list.component.html',
  styleUrls: ['./unit-type-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UnitTypeListComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any[] = [];
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption = 5;
  public searchValue = '';
  totalCount: number = 0;
  public ColumnMode = ColumnMode;
  editingRowId: number | null = null;
  createUnitTypeName = null;

  constructor(
    private unitTypeService: UnitTypeService,
    private toastrService: ToastrService,
    public authService:AuthService) { }

  async ngOnInit() {
    this.unitTypeService.event$.subscribe(async result => {
      await this.getAllUnitType(this.pageBasic - 1, this.selectedSize, this.searchValue);
    });
    await this.getAllUnitType(this.pageBasic - 1, this.selectedSize, this.searchValue);
  }

  async getAllUnitType(page, size, search) {
    this.blockUI.start();
    const data = await this.unitTypeService.getAllUnitType(page, size, search);
    console.log(data);
    this.rows = data.unitTypes;
    this.totalCount = data.totalCount;
    this.blockUI.stop();
  }

  async filterUpdate(event: Event) {
    const input = event.target as HTMLInputElement;
    this.searchValue = input.value.toLowerCase();
    await this.getAllUnitType(this.pageBasic - 1, this.selectedSize, this.searchValue);
  }


  async onPageChange() {
    await this.getAllUnitType(this.pageBasic - 1, this.selectedSize, this.searchValue);
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption);
    await this.getAllUnitType(this.pageBasic - 1, this.selectedSize, this.searchValue);
  }

  isEditingRow(id: number): boolean {
    return this.editingRowId === id;
  }

  editRow(id: number) {
    this.editingRowId = id;
    const row = this.rows.find(row => row.id === id);
    if (row) {
      console.log('Editing:', row.id, row.unitTypeName);
    }
  }

  async saveRow(id: number) {
    this.editingRowId = null;
    const row = this.rows.find(row => row.id === id);
    if (row) {
      console.log('Saved:', row.id, row.unitTypeName);
      const data = await this.unitTypeService.updateUnitType(row.id, row.unitTypeName);
      console.log(data)
      if (data.status) {
        this.unitTypeService.sendEvent(true);
        this.toastrService.success(data.message);
      } else {
        this.toastrService.error(data.message);
      }
    }

  }

  cancelEdit(id: number) {
    this.editingRowId = null;
  }

  async createUnitType(){
    if(this.createUnitTypeName == null){
      this.toastrService.error('Depo adı dolu olmalıdır.')
    }
    const data = await this.unitTypeService.createUnitType(this.createUnitTypeName);
    console.log(data);
    if(data.status == true){
      this.unitTypeService.sendEvent(true);
      this.toastrService.success(data.message);
    }else{
      this.toastrService.error(data.message);
    }
  }

}
